import Button from 'components/Button';
import FormCTA from 'components/FormCTA';
import Heading2 from 'components/Heading/H2';
import Layout from 'components/Layout';
import RecentBlogPosts from 'components/RecentBlogPosts';
import SEO from 'components/seo';
import ServicesCTA from 'components/ServicesCTA';
import CTAWithText from 'containers/CTAWithText';
import DashboardOverviewContainer from 'containers/DashboardOverviewContainer';
import HeroSection from 'containers/HeroSection';
import SplitSectionWithImage from 'containers/SplitSectionWithImage';
import CardsGridWithChildren from 'containers/CardsGridWithChildren';
import ComplianceMonitoringContainer from 'containers/SellingInYourAreaContainer';
import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import RecentPodcasts from 'components/RecentPodcasts';
import useBuildToRentData from '../../pageDataHooks/useBuildToRentData';
import {
  ACTIVE_CAMPAIGN_FORM_IDS,
  ACTIVE_CAMPAIGN_FORM_METAORS,
} from 'utils/addToActiveCampaign';

const BuildToRent = ({ pageContext }) => {
  const { contentfulPage: data } = useBuildToRentData();
  console.log(data);
  return (
    <Layout
      navType="light"
      navLinkType={'light'}
      navBgColor="#ffffff"
      navLinkColor="#ffffff"
      logoType="light"
    >
      <SEO
        description={data.metaDescription.metaDescription}
        title={data.metaTitle}
        useTitleTemplate={false}
      />
      <Helmet>
        <link
          rel="stylesheet"
          type="text/css"
          charset="UTF-8"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
        />
      </Helmet>

      <HeroSection
        mainTitle={
          <>
            {data.heroSections[0]?.primaryTitle} <br />
            <span className="highlight">
              {data.heroSections[0]?.secondaryTitle}
            </span>{' '}
            {data.heroSections[0]?.tertiaryTitle}
          </>
        }
        subTitle={
          <>{data.heroSections[0]?.primaryDescription.primaryDescription}</>
        }
        actions={
          <Button
            $backgroundColor="accent"
            variant="full"
            $withArrow={true}
            onClick={data.heroSections[0]?.button1Url}
            buttonID={data.heroSections[0]?.button1Id}
          >
            {data.heroSections[0]?.botton1Text}
          </Button>
        }
        slug={data.heroSections[0]?.slug}
        imageData={data.heroSections[0]?.image}
        useGracefulImage={true}
      />
      {/* End of HeroSection */}
      <CardsGridWithChildren
        displayStarSvg={data.cardsgridwithchildren[0]?.displayStarSvg1}
        isChildLeft={
          data.cardsgridwithchildren[0]?.displayStarSvg1.isChildLeft || true
        }
        data={data.cardsgridwithchildren[0]?.cardsgridwithchildrendata}
        padding={data.cardsgridwithchildren[0]?.displayStarSvg1.padding}
        inLine={data.cardsgridwithchildren[0]?.displayStarSvg1.isInline}
      />

      <SplitSectionWithImage
        mode={data?.earnRentalReturnWhile?.mode}
        margin={data?.earnRentalReturnWhile?.margin}
        isImageVisibleMobile={data?.earnRentalReturnWhile?.isImageVisibleMobile}
        displayStarSvg={data?.earnRentalReturnWhile?.mode}
        imageData={data?.earnRentalReturnWhile?.image}
        useGracefulImage={true}
      >
        <ServicesCTA
          titleChildren={
            <>
              <Heading2
                text={
                  data?.earnRentalReturnWhile?.servicescta[0]
                    ?.titleChildren1title
                }
                colour={
                  data?.earnRentalReturnWhile?.servicescta[0]
                    ?.titleChildren1Color
                }
              />
              <Heading2
                text={
                  data?.earnRentalReturnWhile?.servicescta[0]
                    ?.titleChildren2title
                }
                colour={
                  data?.earnRentalReturnWhile?.servicescta[0]
                    ?.titleChildren2Color
                }
              />
            </>
          }
          description={
            data?.earnRentalReturnWhile?.servicescta[0]?.description.description
          }
          actionChildren={
            <>
              <Button
                margin="2em 0"
                $backgroundColor="accent"
                variant="full"
                $withArrow={true}
                onClick={data?.earnRentalReturnWhile?.servicescta[0]?.btn1Url}
                buttonID={data?.earnRentalReturnWhile?.servicescta[0]?.btn1Id}
              >
                buttonID={data?.earnRentalReturnWhile?.servicescta[0]?.btn1Text}
              </Button>
            </>
          }
        />
      </SplitSectionWithImage>
      <SplitSectionWithImage
        mode={data?.findThePerfectTenants?.mode}
        isImageLeft={data?.findThePerfectTenants?.isImageLeft}
        margin={data?.findThePerfectTenants?.margin}
        isImageVisibleMobile={data?.findThePerfectTenants?.isImageVisibleMobile}
        displayStarSvg={data?.findThePerfectTenants?.mode}
        imageData={data?.findThePerfectTenants?.image}
        useGracefulImage={true}
      >
        <ServicesCTA
          mode="dark"
          titleChildren={
            <div className="mt-3">
              <Heading2
                text={
                  data?.findThePerfectTenants?.servicescta[0]
                    ?.titleChildren1title
                }
                display="inline"
              />
              <Heading2
                text={
                  data?.findThePerfectTenants?.servicescta[0]
                    ?.titleChildren2title
                }
                colour={
                  data?.findThePerfectTenants?.servicescta[0]
                    ?.titleChildren2Color
                }
                display="inline"
                isUnderlined
              />
              <Heading2
                text={
                  data?.findThePerfectTenants?.servicescta[0]?.heading3Title
                }
              />
            </div>
          }
          description={
            data?.findThePerfectTenants?.servicescta[0]?.description.description
          }
          actionChildren={
            <>
              <Button
                $backgroundColor={
                  data?.findThePerfectTenants?.servicescta[0]?.btn1BgColor
                }
                variant={
                  data?.findThePerfectTenants?.servicescta[0]?.btn1Variant
                }
                buttonID={data?.findThePerfectTenants?.servicescta[0]?.btn1Id}
              />
              <Button
                $backgroundColor={
                  data?.findThePerfectTenants?.servicescta[0]?.button2BgColor
                }
                variant={
                  data?.findThePerfectTenants?.servicescta[0]?.button2Variant
                }
                buttonID={
                  data?.findThePerfectTenants?.servicescta[0]?.button2Id
                }
              />
            </>
          }
        />
      </SplitSectionWithImage>

      <DashboardOverviewContainer
        mode={data?.dashboardOverview[0]?.mode}
        title={data?.dashboardOverview[0]?.title}
        description={data?.dashboardOverview[0]?.description?.description}
        ctaText={data?.dashboardOverview[0]?.ctaText}
        squareSVG={data?.dashboardOverview[0]?.squareSVG}
      />
      <SplitSectionWithImage
        mode={data?.keepUpWithTheMarket?.mode}
        margin={data?.keepUpWithTheMarket?.margin}
        isImageLeft={data?.keepUpWithTheMarket?.isImageLeft}
        isImageVisibleMobile={data?.keepUpWithTheMarket?.isImageVisibleMobile}
        displayStarSvg={data?.keepUpWithTheMarket?.mode}
        imageData={data?.keepUpWithTheMarket?.image}
        useGracefulImage={true}
      >
        <ServicesCTA
          mode="dark"
          titleChildren={
            <>
              <Heading2
                text={
                  data?.keepUpWithTheMarket?.servicescta[0]?.titleChildren1title
                }
              />
              <Heading2
                text={
                  data?.keepUpWithTheMarket?.servicescta[0]?.titleChildren2title
                }
                colour={
                  data?.keepUpWithTheMarket?.servicescta[0]?.titleChildren2Color
                }
                isUnderlined
              />
            </>
          }
          description={
            <p>
              {
                data?.keepUpWithTheMarket?.servicescta[0]?.description
                  .description
              }
            </p>
          }
          actionChildren={
            <>
              <Button
                margin="2em 0"
                $backgroundColor={
                  data?.keepUpWithTheMarket?.servicescta[0]?.btn1BgColor
                }
                $withArrow={true}
                variant={data?.keepUpWithTheMarket?.servicescta[0]?.btn1Variant}
                onClick={data?.keepUpWithTheMarket?.servicescta[0]?.btn1Url}
                buttonID={data?.keepUpWithTheMarket?.servicescta[0]?.btn1Id}
              >
                {data?.keepUpWithTheMarket?.servicescta[0]?.btn1Text}
              </Button>
            </>
          }
        />
      </SplitSectionWithImage>
      <SplitSectionWithImage
        mode={data?.lowVoidTimes?.mode}
        isImageLeft={data?.lowVoidTimes?.isImageLeft}
        margin={data?.lowVoidTimes?.margin}
        isImageVisibleMobile={data?.lowVoidTimes?.isImageVisibleMobile}
        displayStarSvg={data?.lowVoidTimes?.mode}
        imageData={data?.lowVoidTimes?.image}
        useGracefulImage={true}
        padding={data?.lowVoidTimes?.padding}
        padding_top={data?.lowVoidTimes?.paddintTop}
      >
        <ServicesCTA
          //   mode="dark"
          titleChildren={
            <>
              <Heading2
                text={data?.lowVoidTimes?.servicescta[0]?.titleChildren1title}
              />
              <Heading2
                text={data?.lowVoidTimes?.servicescta[0]?.titleChildren2title}
                colour={data?.lowVoidTimes?.servicescta[0]?.titleChildren2Color}
                isUnderlined
              />
            </>
          }
          description={
            <p>{data?.lowVoidTimes?.servicescta[0]?.description.description}</p>
          }
          actionChildren={
            <>
              <Button
                margin="2em 0"
                $withArrow={true}
                $backgroundColor={
                  data?.lowVoidTimes?.servicescta[0]?.btn1BgColor
                }
                variant={data?.lowVoidTimes?.servicescta[0]?.btn1Variant}
                onClick={data?.lowVoidTimes?.servicescta[0]?.btn1Url}
                buttonID={data?.lowVoidTimes?.servicescta[0]?.btn1Id}
              >
                {data?.lowVoidTimes?.servicescta[0]?.btn1Text}
              </Button>
            </>
          }
        />
      </SplitSectionWithImage>

      <ComplianceMonitoringContainer
        mode={data.complianceMonitoring[0]?.mode}
        isImageLeft={data.complianceMonitoring[0]?.isImageLeft}
        padding={data.complianceMonitoring[0]?.isImageLeft}
        displayStarSvg={data.complianceMonitoring[0]?.displayStarSvg}
        removeMargin={data.complianceMonitoring[0]?.removeMargin}
        imageName="rental_price_cards.png"
        imageData={data.complianceMonitoring[0]?.image}
        useGracefulImage={true}
      >
        <FormCTA
          ctaText={data.complianceMonitoring[0]?.formcta[0]?.ctaText}
          titleColor={data.complianceMonitoring[0]?.formcta[0]?.titleColor}
          title={data.complianceMonitoring[0]?.formcta[0]?.title}
          description={
            data.complianceMonitoring[0]?.formcta[0]?.description.description
          }
          acId={ACTIVE_CAMPAIGN_FORM_IDS['BTR_CTA']}
          acMetaOr={ACTIVE_CAMPAIGN_FORM_METAORS['BTR_CTA']}
        />
      </ComplianceMonitoringContainer>

      <RecentBlogPosts posts={pageContext.recentPosts} isSlider />

      <CTAWithText
        ctaText={data.ctaWithText[0]?.button1Text}
        title={
          <span style={{ lineHeight: '1.3', fontSize: 'inherit' }}>
            {data.ctaWithText[0]?.title}
          </span>
        }
        desc={
          <>
            <p style={{ lineHeight: '1.3' }}>
              {data.ctaWithText[0]?.description?.description}
            </p>
          </>
        }
        onClick={data.ctaWithText[0]?.button1Url}
        buttonID="build-to-rent-contact-us-optimise"
      />
      <RecentPodcasts podcasts={pageContext.recentPodcasts} />
    </Layout>
  );
};

BuildToRent.propTypes = {
  pageContext: PropTypes.object,
};

export default BuildToRent;
